import { render, staticRenderFns } from "./MobileModifyCollectionsPage.vue?vue&type=template&id=a7b642ce&scoped=true&"
import script from "./MobileModifyCollectionsPage.vue?vue&type=script&lang=ts&"
export * from "./MobileModifyCollectionsPage.vue?vue&type=script&lang=ts&"
import style0 from "./MobileModifyCollectionsPage.vue?vue&type=style&index=0&id=a7b642ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b642ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VContainer,VIcon,VProgressCircular,VTextField})
